// // import { useState, useEffect, useRef } from "react";

// // export default function TypingPractice() {
// //     const passages = {
// //         junior:
// //          `War affects Global Economy and it has usually proved to be costly to the countries involved. There is increased military expenditure hence hampering the economic growth as most of the countries money is channelled towards the purchase of weaponry and improving the defence. Wars usually reduce the long-run productive capabilities of any nation as the Population Growth is reduced and there is reduced inflow of immigrants. The economic burden of any war is usually placed on the working class and those who have modest education while benefitting a few for instance the war veterans. War is the major hindrance to globalization as it reduces the Global Economic output. It leads to a decline in global investment.

// // Terrorism and war bring doubts which baffle the usual estimation and discourage foreign investors since the business flourish in a nation that is stable politically. Commerce only flourishes where there is Political stability and Economic confidence. During the period of war scarcities is generally make lavishness impossible and not conducive. There is increased inflation with commodity prices being higher than normal hence reducing the purchasing power of the civilians. War leads to unrest, strikes and loss of lives as well. Property is destroyed and the livelihood of many people is significantly tampered with. It leads to people losing their homes and becoming refugees who need economic help. It cripples the economics and destroys industrial infrastructure.`,
// //         senior:
// //             `Sports days are an age old tradition in all schools and interestingly, they are a tradition that has endured. So why? The simple answer is that they remain fit for purpose, and it could be argued that they are even more important now than they have been, all of us who have attended the recent Garden International School sports day will have experienced how much inter-house competition means to the student. The house system has an important role in how student and staff construct their sense of belonging. It is an essential part of schools and can be defined as the feeling of belonging, security and relationships.

// // Belonging is a critical factor in improving engagement learning and performance. It is enhanced through acceptance, inclusion and developing personal identity. Sports days have enhanced this by making them inclusive, adding team elements to their events, and helping students feel part of the whole sports days create a bridge for students to become involved in active co-curricular activities of their choice, fostering the view of exercise as a central part of their habits.

// // Sports days offer a softer way into competing for those who choose competitive sports as their way of staying healthy. Sports activities not only help the students in maintaining physical fitness but also helps them in learning lessons for life.

// // Students learn about the importance of discipline, time management, team work, punctuality, leadership etc. The students develop sportsman spirit within the environment of healthy competition and they learn to overcome difficult situation with the skills of quick decision making and discussion with the team members. Incorporating sports activities into school curricular or encouraging children to participate in extracurricular sports programmes can have lasting positive effects on their physical, mental, emotional and social development. Overall, sports provide a holistic learning experience that shapes us into well-round individuals with qualities such as team work, discipline and a positive attitude towards challenges. These lessons gained from sports can positively impact various aspects of our personal and professional lines.`,
// //     };

// //     const [level, setLevel] = useState(null);
// //     const [passage, setPassage] = useState("");
// //     const [input, setInput] = useState("");
// //     const [time, setTime] = useState(0);
// //     const [started, setStarted] = useState(false);
// //     const [paused, setPaused] = useState(false);
// //     const [finished, setFinished] = useState(false);

// //     const activeCharRef = useRef(null);

// //     // Timer
// //     useEffect(() => {
// //         let timer;
// //         if (started && !paused && !finished) {
// //             timer = setInterval(() => setTime((t) => t + 1), 1000);
// //         }
// //         return () => clearInterval(timer);
// //     }, [started, paused, finished]);

// //     // Auto scroll
// //     useEffect(() => {
// //         if (activeCharRef.current) {
// //             activeCharRef.current.scrollIntoView({
// //                 behavior: "smooth",
// //                 block: "center",
// //             });
// //         }
// //     }, [input]);

// //     const startTest = (selectedLevel) => {
// //         setLevel(selectedLevel);
// //         setPassage(passages[selectedLevel]);
// //         setInput("");
// //         setTime(0);
// //         setStarted(false);
// //         setPaused(false);
// //         setFinished(false);
// //     };

// //     const handleChange = (e) => {
// //         if (paused || finished) return;
// //         if (!started) setStarted(true);

// //         const value = e.target.value;
// //         if (value.length > passage.length) return;

// //         setInput(value);

// //         if (value.length === passage.length) {
// //             setFinished(true);
// //         }
// //     };

// //     // Stats
// //     const correctChars = input
// //         .split("")
// //         .filter((c, i) => c === passage[i]).length;

// //     const errors = input.length - correctChars;
// //     const words = correctChars / 5;
// //     const minutesTyped = time / 60 || 1 / 60;
// //     const wpm = Math.round(words / minutesTyped);
// //     const accuracy = input.length
// //         ? Math.round((correctChars / input.length) * 100)
// //         : 0;

// //     // Time display
// //     const minutes = Math.floor(time / 60);
// //     const seconds = time % 60;
// //     const timeDisplay =
// //         minutes > 0
// //             ? seconds > 0
// //                 ? `${minutes} min ${seconds} sec`
// //                 : `${minutes} min`
// //             : `${seconds} sec`;

// //     return (
// //         <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
// //             <div className="max-w-4xl w-full bg-white shadow-lg rounded-xl p-6 space-y-6">

// //                 <h1 className="text-2xl font-bold text-center text-blue-600">
// //                     English Typing Practice
// //                 </h1>

// //                 {/* Level Selection */}
// //                 {!level && (
// //                     <div className="flex justify-center gap-4">
// //                         <button
// //                             onClick={() => startTest("junior")}
// //                             className="px-6 py-2 bg-green-600 text-white rounded-lg"
// //                         >
// //                             Junior
// //                         </button>
// //                         <button
// //                             onClick={() => startTest("senior")}
// //                             className="px-6 py-2 bg-blue-600 text-white rounded-lg"
// //                         >
// //                             Senior
// //                         </button>
// //                     </div>
// //                 )}

// //                 {level && (
// //                     <>
// //                         {/* Passage */}
// //                         <div className="border rounded-lg p-4 h-64 overflow-y-auto text-lg font-mono leading-relaxed">
// //                             {passage.split("").map((char, i) => {
// //                                 let className = "text-gray-400";

// //                                 if (i < input.length) {
// //                                     className =
// //                                         input[i] === char
// //                                             ? "text-green-600"
// //                                             : "text-red-600";
// //                                 } else if (i === input.length && !finished) {
// //                                     className = "text-blue-600 underline";
// //                                 }

// //                                 return (
// //                                     <span
// //                                         key={i}
// //                                         ref={i === input.length ? activeCharRef : null}
// //                                         className={className}
// //                                     >
// //                                         {char}
// //                                     </span>
// //                                 );
// //                             })}
// //                         </div>

// //                         {/* Input */}
// //                         <textarea
// //                             value={input}
// //                             onChange={handleChange}
// //                             disabled={paused || finished}
// //                             spellCheck={false}
// //                             placeholder={
// //                                 finished
// //                                     ? "Test Completed"
// //                                     : paused
// //                                         ? "Paused"
// //                                         : "Start typing here..."
// //                             }
// //                             className="w-full h-32 p-3 border rounded-lg font-mono text-lg focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100"
// //                         />

// //                         {/* Controls */}
// //                         <div className="flex justify-center gap-4">
// //                             {!finished && (
// //                                 <button
// //                                     onClick={() => setPaused((p) => !p)}
// //                                     className="px-6 py-2 bg-yellow-500 text-white rounded-lg"
// //                                 >
// //                                     {paused ? "Continue ▶" : "Pause ⏸"}
// //                                 </button>
// //                             )}
// //                         </div>

// //                         {/* Stats */}
// //                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
// //                             <div className="bg-blue-50 p-3 rounded-lg">
// //                                 <p className="text-sm text-gray-600">Time</p>
// //                                 <p className="text-xl font-bold">{timeDisplay}</p>
// //                             </div>

// //                             <div className="bg-green-50 p-3 rounded-lg">
// //                                 <p className="text-sm text-gray-600">WPM</p>
// //                                 <p className="text-xl font-bold">{wpm}</p>
// //                             </div>

// //                             <div className="bg-yellow-50 p-3 rounded-lg">
// //                                 <p className="text-sm text-gray-600">Accuracy</p>
// //                                 <p className="text-xl font-bold">{accuracy}%</p>
// //                             </div>

// //                             <div className="bg-red-50 p-3 rounded-lg">
// //                                 <p className="text-sm text-gray-600">Errors</p>
// //                                 <p className="text-xl font-bold">{errors}</p>
// //                             </div>
// //                         </div>

// //                         {finished && (
// //                             <p className="text-center text-green-600 font-semibold">
// //                                 ✅ Test Completed ({level.toUpperCase()})
// //                             </p>
// //                         )}
// //                     </>
// //                 )}
// //             </div>
// //         </div>
// //     );
// // }
// import { useState, useEffect, useRef } from "react";

// export default function TamilTypingPractice() {
//     const passages = {
//         junior: `தமிழ் ஒரு செம்மொழி ஆகும். இது உலகின் மிகப் பழமையான மொழிகளில் ஒன்றாகும். 
// தமிழ் மொழி இலக்கிய வளமிக்கதாகும். சங்க இலக்கியங்கள் தமிழின் பெருமையை எடுத்துரைக்கின்றன.
// தமிழ் பேசும் மக்கள் உலகம் முழுவதும் வாழ்ந்து வருகின்றனர். 
// தமிழ் மொழி கலாச்சாரத்தையும் பண்பாட்டையும் பிரதிபலிக்கிறது.`,

//         senior: `தமிழ் மொழி இந்தியாவின் மிக முக்கியமான பாரம்பரிய மொழிகளில் ஒன்றாகும். 
// இது ஆயிரக்கணக்கான ஆண்டுகளாக தொடர்ந்து பேசப்பட்டு வரும் மொழியாகும்.
// தமிழ் இலக்கியங்கள் மனித வாழ்வின் அனைத்து அம்சங்களையும் எடுத்துரைக்கின்றன.
// தமிழ் மொழி கல்வி, அறிவியல், கலை, இலக்கியம் மற்றும் பண்பாட்டில் சிறந்து விளங்குகிறது.
// தமிழ் பேசும் சமூகங்கள் தங்கள் மொழியை பாதுகாக்கவும் வளர்க்கவும் பெரும் பங்கு வகிக்கின்றனர்.
// தமிழ் மொழி இன்று கணினி மற்றும் இணைய உலகிலும் முக்கிய இடம் பெற்றுள்ளது.`
//     };

//     const [level, setLevel] = useState(null);
//     const [passage, setPassage] = useState("");
//     const [input, setInput] = useState("");
//     const [time, setTime] = useState(0);
//     const [started, setStarted] = useState(false);
//     const [paused, setPaused] = useState(false);
//     const [finished, setFinished] = useState(false);

//     const activeCharRef = useRef(null);

//     // Timer
//     useEffect(() => {
//         let timer;
//         if (started && !paused && !finished) {
//             timer = setInterval(() => setTime(t => t + 1), 1000);
//         }
//         return () => clearInterval(timer);
//     }, [started, paused, finished]);

//     // Auto scroll active character
//     useEffect(() => {
//         if (activeCharRef.current) {
//             activeCharRef.current.scrollIntoView({
//                 behavior: "smooth",
//                 block: "center"
//             });
//         }
//     }, [input]);

//     const startTest = (selectedLevel) => {
//         setLevel(selectedLevel);
//         setPassage(passages[selectedLevel]);
//         setInput("");
//         setTime(0);
//         setStarted(false);
//         setPaused(false);
//         setFinished(false);
//     };

//     const handleChange = (e) => {
//         if (paused || finished) return;
//         if (!started) setStarted(true);

//         const value = e.target.value;
//         if (value.length > passage.length) return;

//         setInput(value);

//         if (value.length === passage.length) {
//             setFinished(true);
//         }
//     };

//     // Stats
//     const correctChars = input
//         .split("")
//         .filter((c, i) => c === passage[i]).length;

//     const errors = input.length - correctChars;
//     const words = correctChars / 5;
//     const minutesTyped = time / 60 || 1 / 60;
//     const wpm = Math.round(words / minutesTyped);
//     const accuracy = input.length
//         ? Math.round((correctChars / input.length) * 100)
//         : 0;

//     // Time display
//     const minutes = Math.floor(time / 60);
//     const seconds = time % 60;
//     const timeDisplay =
//         minutes > 0
//             ? `${minutes} நிமி ${seconds} வி`
//             : `${seconds} வி`;

//     return (
//         <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
//             <div className="max-w-4xl w-full bg-white shadow-lg rounded-xl p-6 space-y-6">

//                 <h1 className="text-2xl font-bold text-center text-blue-600">
//                     தமிழ் தட்டச்சு பயிற்சி (Alt + 3)
//                 </h1>

//                 {/* Level Selection */}
//                 {!level && (
//                     <div className="flex justify-center gap-4">
//                         <button
//                             onClick={() => startTest("junior")}
//                             className="px-6 py-2 bg-green-600 text-white rounded-lg"
//                         >
//                             Junior
//                         </button>
//                         <button
//                             onClick={() => startTest("senior")}
//                             className="px-6 py-2 bg-blue-600 text-white rounded-lg"
//                         >
//                             Senior
//                         </button>
//                     </div>
//                 )}

//                 {level && (
//                     <>
//                         {/* Passage */}
//                         <div className="border rounded-lg p-4 h-64 overflow-y-auto text-lg leading-relaxed font-sans">
//                             {passage.split("").map((char, i) => {
//                                 let className = "text-gray-400";

//                                 if (i < input.length) {
//                                     className =
//                                         input[i] === char
//                                             ? "text-green-600"
//                                             : "text-red-600";
//                                 } else if (i === input.length && !finished) {
//                                     className = "text-blue-600 underline";
//                                 }

//                                 return (
//                                     <span
//                                         key={i}
//                                         ref={i === input.length ? activeCharRef : null}
//                                         className={className}
//                                     >
//                                         {char}
//                                     </span>
//                                 );
//                             })}
//                         </div>

//                         {/* Input */}
//                         <textarea
//                             value={input}
//                             onChange={handleChange}
//                             disabled={paused || finished}
//                             spellCheck={false}
//                             placeholder={
//                                 finished
//                                     ? "பயிற்சி முடிந்தது"
//                                     : paused
//                                         ? "இடைநிறுத்தம்"
//                                         : "Alt + 3 தமிழ் தட்டச்சு தொடங்கவும்..."
//                             }
//                             className="w-full h-32 p-3 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100"
//                         />

//                         {/* Controls */}
//                         <div className="flex justify-center gap-4">
//                             {!finished && (
//                                 <button
//                                     onClick={() => setPaused(p => !p)}
//                                     className="px-6 py-2 bg-yellow-500 text-white rounded-lg"
//                                 >
//                                     {paused ? "தொடரவும் ▶" : "இடைநிறுத்தம் ⏸"}
//                                 </button>
//                             )}
//                         </div>

//                         {/* Stats */}
//                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
//                             <div className="bg-blue-50 p-3 rounded-lg">
//                                 <p className="text-sm text-gray-600">நேரம்</p>
//                                 <p className="text-xl font-bold">{timeDisplay}</p>
//                             </div>

//                             <div className="bg-green-50 p-3 rounded-lg">
//                                 <p className="text-sm text-gray-600">WPM</p>
//                                 <p className="text-xl font-bold">{wpm}</p>
//                             </div>

//                             <div className="bg-yellow-50 p-3 rounded-lg">
//                                 <p className="text-sm text-gray-600">துல்லியம்</p>
//                                 <p className="text-xl font-bold">{accuracy}%</p>
//                             </div>

//                             <div className="bg-red-50 p-3 rounded-lg">
//                                 <p className="text-sm text-gray-600">பிழைகள்</p>
//                                 <p className="text-xl font-bold">{errors}</p>
//                             </div>
//                         </div>

//                         {finished && (
//                             <p className="text-center text-green-600 font-semibold">
//                                 ✅ பயிற்சி முடிந்தது ({level.toUpperCase()})
//                             </p>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// }
import { useState, useEffect, useRef } from "react";

export default function TypingPractice() {

    const passages = {
        english: {
            junior: `Keeping in mind the divine comedy, the great comedian actor Milton Berle said that, “Laughter is an instant holiday”. These lines of the legendary actors state the significance of laughing in one’s life. Human life is full of stress and happiness. In such a living, the humour of a few moments makes you feel humorous for a long time. There are much more sad moments in life rather than happiness. The person may be so overwhelmed by the burden of sorrow that he will not even be able to enjoy the availability of pleasure from life. In these worst scenarios, the gift of laughter makes one bearable.

            
Laughter is the best communicative milestone in human’s development and starts evolving from a baby’s giggle. It can be used as an emotional release mechanism and supports one to be popular. Laughter is one of the most important gift God gives to the human being. Humour makes the brain brilliant, the mind fresh, boosts energy inside the body and keeps the body system fine.

Laughter is key to boost immunity power in the human body. Laughter has a tendency to help burn calories from the human body. The studies even stated that laughing for 15 minutes a day will help to burn 40 calories. Laughter brings a distraction from negative emotions such as depression, anger, stress, guilt and all others more effectively than the other means of distractions. In short, laughter helps us to create a frame of mind in which we can more effectively cope with the struggle of life.`,

            senior: `According to experts, oat bran, the grain’s outer fiber-rich covering may aid in the relief of constipation in older adults. People with ulcerative colitis who consume oat bran also see a reduction in gastrointestinal symptoms and improved digestion. Also, the soluble fibers in oats works well to prevent constipation. Furthermore, you can add muesli to your bowl of oats muesli benefits in bowel movement due to its rich fiber profile. Oats have complex carbohydrates and melatonin. These help more tryptophan get in the brain, as a result of which it helps in getting better sleep. Benefits of oatmeal are endless. Apart from adding oatmeal in diet, you can even apply to your skin and hair to get best results.

Colon cancer is one of the most common types of cancer and it is very painful. One of the research was conducted in the United Kingdom and the Netherlands, in which it was found that people who consumed a high fiber cereal had a lesser risk of colon cancer. This consists of iron, fiber, omega six fatty acids, zinc, and fatty acids, which are hair-friendly to the hair. On regular consumption the hair.

On regular consumption nutrients and help in the growth of and application, your hair will become thicker and longer. Oatmeal can even be fed to babies as it is easy on the digestive system of the little ones. Also, it is a natural laxative; thus, babies are lesser likely to feel constipated. Now, if you think oatmeal can be a great option to go for, do not make any delay and buy the least processed oats. You can choose anything from whole grain oats, steel cut oats, or even instant oats.

Oats are widely eaten as the breakfast meal, which is cooked by boiling oats in water or milk. Porridge is other common name used for oatmeal. To make the oatmeal, turn on heat in a pot and add huge milk with two teaspoon of sugar or pure honey. When the milk begins to boil, add half cup of rolled oats. Stir the oats for about five minutes and then add half teaspoon of cinnamon powder. When finished add some exotic dry fruits of your choice. Now, empty the pot into a bowl and marinate the oats with desired topping of your choice. Your oatmeal is ready to served and eaten after five minutes of sitting.`
        },
        tamil: {
            junior: `இயற்கை வளங்கள் எப்போதும் பூமியில் இயற்கையாகவே கிடைக்கும் வளங்கள். இது நம் வாழ்க்கையின் ஒரு துணிக்குப் பூமியாகும். இயற்கை வளங்கள் காற்று, நீர், நிலம், தாவரங்கள், விலங்குகள், இயற்கை சார்ந்த எண்ணெய் போன்றவற்றைக் கொண்டுள்ளன. இருப்பினும், மனிதனால் இந்த வளங்கள் தவறாக பயன்படுத்தப்படுவதால் அவற்றின் அளவு குறைந்து வருகிறது. இந்த வளங்கள் மனித வாழ்விற்கு இன்றியமையாதவை. அவற்றை பாதுகாப்பது என்பது நமது கடமை.

பாதுகாப்பு என்பது காற்று, நீர்நிலைகள், இயற்கை காடுகள், கனிமங்கள் மற்றும் எல்லாவற்றையும் சரியான முறையில் பயன்படுத்துவதாகும். இதனால் அவை தொடர்ந்து சரியான நிலையில் பயன்படுகின்றன. மனிதன் தனது தேவைக்காக இயற்கை வளங்களை அதிகமாக பயன்படுத்துவதால் அவற்றின் சமநிலை பாதிக்கப்படுகிறது. இதனால் உலகம் இன்று பல்வேறு சுற்றுச்சூழல் பிரச்சினைகளை எதிர்கொள்கிறது.

இயற்கை சார்ந்த அதிக அளவிலான உற்பத்தி செயல்கள் சுற்றுச்சூழலை பாதிக்கின்றன. இயற்கை வளங்களை சேமிப்பதன் மூலம் மட்டுமே எதிர்கால தலைமுறைக்கு அவற்றை பாதுகாக்க முடியும். மேலும் இந்த வளங்கள் சரியான முறையில் பயன்படுத்தப்பட்டால், மனித வாழ்க்கை மேலும் மேம்படும்.

இயற்கை வளங்களை பாதுகாப்பது மனிதனின் முக்கிய பொறுப்பாகும். இதற்காக மரங்கள் நடுதல், நீர்நிலைகளை சுத்தமாக வைத்தல், மாசுபாட்டை குறைத்தல் போன்ற நடவடிக்கைகள் அவசியமாகும். இதன் மூலம் இயற்கையின் சமநிலை காக்கப்பட்டு, பூமியின் எதிர்காலம் பாதுகாக்கப்படும்.`,
            senior: `சிலம்பம் என்பது தமிழ் நாட்டின் பல்வேறு சிலம்பப் பள்ளிகளால் குறித்த பாரம்பரியமான ஒரு யுத்தக் கலை, தற்காப்புக் கொடுக்கப் பள்ளிகள் இயங்கி வருகின்றன. கலை மற்றும் கம்பு சுற்றும் வீர விளையாட்டாகும். உடல் திறன், மன வலிமை, மற்றும் யுத்த ஆரியப்படை, திருச்செந்தூரில் சிலம்பப் திறன்களை வளர்க்கும் ஒரு பழைமையான கலை பயிற்சியளிக்கும் உரிமையை அங்கீகரித்து அரசாங்கம் சிலம்பத்திற்கு உண்டு. இது வழக்கில் 'கம்பு வழங்கியது. இதிலிருந்து தென் மாவட்டங்கள் அங்கீகாரம் பெற்று சிலம்பத்தில் வீரர்கள் சிலம்பத்தில் பல மாற்றங்களைக் கட்ட சுற்றும்' என்றும் அழைக்கப்படுகிறது. சிலம்பம் என்பது, கையில் வைத்திருக்கும் நீண்ட கம்புப் பொறித்தார்கள், ஊமைத்துரை, மருதுபாண்டியர், புலித்தேவன் போன்றவர்கள் ஆங்கிலேயரின் இராணுவ வலிமையால் அடக்கப்பட்டுத் தூக்கில் இடப்பட்டார்கள். இவர்களுடைய காலத்தில் தூப்பாக்கிகளுடன் ஆயுதப் படையையும், மீண்டும் சிலம்பத்தில் ஈடுபாடடையப் பல முன்னோச்சரிக்கை நடவடிக்கைகளை ஆங்கிலேயர் தொடர்ந்தனர். மூலம், தாக்குதல் மற்றும் தற்காப்பு செய்யும் ஒரு சிலம்பம் கலை வடிவம். சிலம்பம் என்றால் மலை, மற்றும் பாம் என்பது பாம்பின் சுழற்சியான வடிவம் என்றும் பொருள். 'மலையில் இருந்த மூங்கில்' என்பதுதான் இதன் பொருளாகும். சிலம்பத்தில் பயன்படுத்தப்படும் கச்சி சுமார் மூன்றரை அடி நீளமும், மூன்றரை அங்குலம் எடையும் கொண்டது. சென்னைச் சிலம்பம் பாரம்பரியமும், கங்கைகொண்டான், சர்க்கரை நயினார் கோவில், ஆற்காடு அருந்ததி, கள்ளக்குறிச்சி பகுதிகளில் மொத்தம் இருபத்திஎட்டு கோட்டைகள் அடித்து சிலம்பம் நடைமுறையில் உலோகச் சட்டைகள், ஈட்டிகள் மற்றும் மான்கொம்பு போன்ற ஆயுதங்களைப் பயன்படுத்தவும் அடங்கும்.

சங்க இலக்கியங்களான மணிமேகலை மற்றும் சிலப்பதிகாரம் ஆகியவற்றில் சிலம்பம் பற்றிய குறிப்புகள் காணப்படுகின்றன. இதிலிருந்து, சிலம்பம் கி.மு. நான்காம் நூற்றாண்டுக்கு முன்பே இருந்திருக்கலாம் என்று கருதப்படுகிறது. பல்லவர்கள், சோழர்கள் மற்றும் பாண்டியர்கள் போன்ற தமிழ் மன்னர்களின் ஆட்சிக் காலத்தில் சிலம்பம் வளர்ந்து, போர்களில் முக்கியப் பங்கு வகித்தது. காலப்போக்கில் சிலம்பம் பயிற்சி சற்றுக் குறைந்தாலும், சுதந்திரத்திற்குப் பின்னர் மீண்டும் புத்துணர்வு பெற்றது. இன்று, தமிழ்நாட்டில் நிறுவப்பட்டிருப்பதாகத் தகவல்கள் தெரிவிக்கின்றன. இன்று, தமிழ்நாட்டில் பல நூற்றாண்டுகளுக்கு முன்பே சிலம்பம் எனும் இவ் பாரம்பரியக் கலை இன்றும் உயிர்ப்புடன் உள்ளது. இன்று, தமிழ்நாட்டில் பல சிலம்பப் பள்ளிகள் செயல்பட்டு வருகின்றன. சிலம்பம் பயிற்சி மூலம் உடலில் வளைந்துத் தன்மை, வேகம், பலம், மற்றும் ஒருங்கிணைப்புத் திறன் அதிகரிக்கிறது. சிலம்பம் குறித்த விழிப்புணர்வுகள் அனுபவம் வாய்ந்த ஆசிரியரிடம் பயிற்சி பெறுவது அவசியம். தமிழ்நாட்டில் பல சிலம்பப் பயிற்சி நிலையங்கள் உள்ளன. தற்போது, அனைத்துப் பள்ளிகளிலும் சிலம்பம் குறித்துத் தரப்படுகிறது.`
        }
    };

    const [language, setLanguage] = useState(null); // english | tamil
    const [level, setLevel] = useState(null);       // junior | senior
    const [passage, setPassage] = useState("");
    const [input, setInput] = useState("");
    const [time, setTime] = useState(0);
    const [started, setStarted] = useState(false);
    const [paused, setPaused] = useState(false);
    const [finished, setFinished] = useState(false);

    const activeCharRef = useRef(null);

    // Timer
    useEffect(() => {
        let timer;
        if (started && !paused && !finished) {
            timer = setInterval(() => setTime(t => t + 1), 1000);
        }
        return () => clearInterval(timer);
    }, [started, paused, finished]);

    // Auto-scroll
    useEffect(() => {
        if (activeCharRef.current) {
            activeCharRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [input]);

    const startTest = (lang, lvl) => {
        setLanguage(lang);
        setLevel(lvl);
        setPassage(passages[lang][lvl]);
        setInput("");
        setTime(0);
        setStarted(false);
        setPaused(false);
        setFinished(false);
    };

    const handleChange = (e) => {
        if (paused || finished) return;
        if (!started) setStarted(true);

        const value = e.target.value;
        if (value.length > passage.length) return;

        setInput(value);
        if (value.length === passage.length) setFinished(true);
    };

    // Stats
    const correctChars = input
        .split("")
        .filter((c, i) => c === passage[i]).length;

    const errors = input.length - correctChars;
    const words = correctChars / 5;
    const minutesTyped = time / 60 || 1 / 60;
    const wpm = Math.round(words / minutesTyped);
    const accuracy = input.length
        ? Math.round((correctChars / input.length) * 100)
        : 0;

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    const timeDisplay =
        minutes > 0
            ? `${minutes} ${language === "tamil" ? "நிமி" : "min"} ${seconds} ${language === "tamil" ? "வி" : "sec"}`
            : `${seconds} ${language === "tamil" ? "வி" : "sec"}`;

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="max-w-4xl w-full bg-white shadow-lg rounded-xl p-6 space-y-6">

                <h1 className="text-2xl font-bold text-center text-blue-600">
                    Typing Practice (English / தமிழ்)
                </h1>

                {/* Language Selection */}
                {!language && (
                    <div className="flex justify-center gap-4">
                        <button
                            onClick={() => setLanguage("english")}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg"
                        >
                            English
                        </button>
                        <button
                            onClick={() => setLanguage("tamil")}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg"
                        >
                            தமிழ்
                        </button>
                    </div>
                )}

                {/* Level Selection */}
                {language && !level && (
                    <div className="flex justify-center gap-4">
                        <button
                            onClick={() => startTest(language, "junior")}
                            className="px-6 py-2 bg-purple-600 text-white rounded-lg"
                        >
                            Junior
                        </button>
                        <button
                            onClick={() => startTest(language, "senior")}
                            className="px-6 py-2 bg-indigo-600 text-white rounded-lg"
                        >
                            Senior
                        </button>
                    </div>
                )}

                {level && (
                    <>
                        {/* Passage */}
                        <div className="border rounded-lg p-4 h-64 overflow-y-auto text-lg leading-relaxed">
                            {passage.split("").map((char, i) => {
                                let className = "text-gray-400";

                                if (i < input.length) {
                                    className =
                                        input[i] === char
                                            ? "text-green-600"
                                            : "text-red-600";
                                } else if (i === input.length && !finished) {
                                    className = "text-blue-600 underline";
                                }

                                return (
                                    <span
                                        key={i}
                                        ref={i === input.length ? activeCharRef : null}
                                        className={className}
                                    >
                                        {char}
                                    </span>
                                );
                            })}
                        </div>

                        {/* Input */}
                        <textarea
                            value={input}
                            onChange={handleChange}
                            disabled={paused || finished}
                            spellCheck={false}
                            placeholder={
                                finished
                                    ? language === "tamil" ? "பயிற்சி முடிந்தது" : "Test Completed"
                                    : paused
                                        ? language === "tamil" ? "இடைநிறுத்தம்" : "Paused"
                                        : language === "tamil"
                                            ? "Alt + 3 தமிழ் தட்டச்சு தொடங்கவும்..."
                                            : "Start typing here..."
                            }
                            className="w-full h-32 p-3 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100"
                        />

                        {/* Controls */}
                        {!finished && (
                            <div className="flex justify-center">
                                <button
                                    onClick={() => setPaused(p => !p)}
                                    className="px-6 py-2 bg-yellow-500 text-white rounded-lg"
                                >
                                    {paused
                                        ? language === "tamil" ? "தொடரவும் ▶" : "Continue ▶"
                                        : language === "tamil" ? "இடைநிறுத்தம் ⏸" : "Pause ⏸"}
                                </button>
                            </div>
                        )}

                        {/* Stats */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                            <Stat title={language === "tamil" ? "நேரம்" : "Time"} value={timeDisplay} />
                            <Stat title="WPM" value={wpm} />
                            <Stat title={language === "tamil" ? "துல்லியம்" : "Accuracy"} value={`${accuracy}%`} />
                            <Stat title={language === "tamil" ? "பிழைகள்" : "Errors"} value={errors} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

function Stat({ title, value }) {
    return (
        <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm text-gray-600">{title}</p>
            <p className="text-xl font-bold">{value}</p>
        </div>
    );
}
